var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Layout from '../components/layout';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import LogoImage from '../../public/Time-to-Rock-Festival-custom-2026.webp';
import { useSession } from 'next-auth/react';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { ContentDisplay } from '../components/contentDisplay';
export default function IndexPage() {
    var _a;
    const { data: session } = useSession();
    const { locale } = useRouter();
    const langCode = (_a = locale === null || locale === void 0 ? void 0 : locale.substring(0, 2)) !== null && _a !== void 0 ? _a : 'en';
    const contentKey = 'start page';
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            // window.signIn = signIn();
        }))();
    }, [session, langCode]);
    return (<Layout>
      <Image src={LogoImage.src} alt="Time To Rock festival 3 - 6 Juli 2026" style={{ width: '100%' }}/>

      <Row>
        <Col md={{ offset: 2, span: 8 }} sm={12}>
          <ContentDisplay contentKey={contentKey} languageCode={langCode}/>
        </Col>
      </Row>
    </Layout>);
}
